import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
  AfterViewInit,
  ViewChild,
} from '@angular/core';
import { FormComponent } from '../form.components';
import { ControlContainer } from '@angular/forms';
import { Chips } from 'primeng/chips';

@Component({
  selector: 'hospitality-bot-chip-list',
  templateUrl: './chip-list.component.html',
  styleUrls: ['./chip-list.component.scss'],
})
export class ChipListComponent extends FormComponent
  implements OnInit, AfterViewInit {
  @Output() onRemove = new EventEmitter();
  @Output() onAddItem = new EventEmitter();
  @Input() id: string;
  @Input() maxLength: number;
  @ViewChild('chips') chips: Chips;

  constructor(public controlContainer: ControlContainer) {
    super(controlContainer);
  }

  ngOnInit(): void {
    this.initInputControl();
  }

  handleRemove(event: { originalEvent: PointerEvent; value: string }) {
    event.originalEvent.stopPropagation();
    this.onRemove.emit(event.value);
  }

  handelOnAdd(event: { originalEvent: PointerEvent; value: string }) {
    this.onAddItem.emit(event.value);
  }

  ngAfterViewInit(): void {
    const inputElement = document.getElementById(this.id);
    inputElement &&
      inputElement?.setAttribute('maxlength', this.maxLength?.toString());
  }

  get getInputClass() {
    return Object.assign(
      { 'prefix-wrapper': !!this.prefix },
      this.inputNgClasses
    );
  }
}
